<div class="booking-page-container">
    <app-page-title>
        <h1>Foglalj most!</h1>
        <h2>Válaszd ki a kívánt időpontot és gyere kapcsolj ki!</h2>
    </app-page-title>
    <div class="booking-page-body-container">
        <div class="booking-container">
            <div class="booking-form">
                <div class="box booking-date">
                    <h2>1. Időszak</h2>
                    <div class="input-block">
                        <p>Érkezés</p>
                        <input type="date" [formControl]="fromDate" />
                    </div>
                    <div class="input-block">
                        <p>Távozás</p>
                        <input type="date" [formControl]="toDate" />
                    </div>
                </div>

                <div class="box booking-guests">
                    <h2>2. Vendégek</h2>
                    <div class="input-block">
                        <p>Felnőttek száma</p>
                        <input type="number" min="1" [formControl]="numberOfGuests" />
                    </div>
                    <div class="input-block">
                        <p>Gyermekek száma</p>
                        <input type="number" min="0" [formControl]="numberOfChildren" />
                    </div>
                </div>

                <div class="box booking-informations">
                    <h2>3. Alapadatok</h2>
                    <div class="input-block">
                        <p>Név</p>
                        <input type="text" [formControl]="name" />
                    </div>
                    <div class="input-block">
                        <p>Cím</p>
                        <input type="text" [formControl]="address" />
                    </div>
                    <div class="input-block">
                        <p>Ország</p>
                        <input type="text" [formControl]="country" />
                    </div>

                    <div class="input-block">
                        <p>Email</p>
                        <input type="email" [formControl]="email" />
                    </div>
                    <div class="input-block">
                        <p>Telefonszám</p>
                        <input type="tel" [formControl]="phone" />
                    </div>
                </div>

                <div class="booking-actions">
                    <app-button [text]="'Foglalás megerősítése'" (buttonClick)="onSubmit()"/>
                </div>
            </div>
        </div>
    </div>
</div>